/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { ChevronsUpDown, LoaderCircle, Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Input } from "@/components/ui/input";
import { InViewComponent } from "@/components/shared/in-view-component";

type ErpSkuProp = {
  placeholder: string;
  isPending: boolean;
  value: string;
  emptyListMessage?: string;
  searchLabel?: string;
  onChange: (prop: string) => void;
  onSearch: (prop: string) => Promise<void>;
  onBlur: () => void;
};

export const SupplierMappingList = ({
  placeholder,
  searchLabel,
  emptyListMessage,
  value,
  onChange,
  onSearch,
  onBlur,
  isPending,
}: ErpSkuProp) => {
  const [searchText, setSearchText] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [process, setProcess] = React.useState(false);
  const [list, setList] = React.useState<any>([]);

  const onChangeValue = (prop: string) => {
    onChange(prop);
  };

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchText === "") {
        setList([]);
        setProcess(false);
        return;
      }
      setList([]);
      setProcess(true);
      try {
        const response: any = await onSearch(searchText);
        if (response?.data) {
          setList(response.data);
        }
      } finally {
        setProcess(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  // const isCurrentOptionIsFiltered = (label: string) => {
  //   const localLabel = label.toLowerCase();
  //   const localSearchText = searchText.toLowerCase();

  //   return localLabel.includes(localSearchText) || false;
  // };

  // const displayOptionsLabel = ({
  //   supplier_name,
  //   pin_code,
  //   address1,
  //   address2,
  //   country,
  //   city,
  // }: {
  //   supplier_name: string;
  //   address_id: string;
  //   branch_id: string;
  //   country: string;
  //   address1: string;
  //   address2: string;
  //   city: string;
  //   pin_code: string;
  // }) => {
  //   return `<span><b class="text-[#6982a7] font-[500]">Customer Name: </b>${supplier_name}</span>
  //     <span><b class="text-[#6982a7]  font-[500]">Branch_name: </b>${address1}</span>
  //     <span><b class="text-[#6982a7]  font-[500]">Address 1: </b>${address2}</span>
  //     <span><b class="text-[#6982a7]  font-[500]">Address 2: </b>${country}</span>
  //     <span><b class="text-[#6982a7]  font-[500]">Address 2: </b>${city}</span>
  //     <span><b class="text-[#6982a7]  font-[500]">Address 2: </b>${pin_code}</span>
  //     `;
  // };

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild onBlur={onBlur}>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className="w-full justify-between "
          >
            <span className="flex-1 truncate text-left">
              {value || placeholder || "Select Options..."}
            </span>
            {isPending ? (
              <LoaderCircle className="animate-spin" />
            ) : (
              <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[400px] p-0" align="end">
          <Command>
            <div className="p-1">
              <div className="flex">
                <Button className="absolute" size={"icon"} variant={"ghost"}>
                  <Search />
                </Button>
                <Input
                  className="!outline-none !border-none pl-10 focus:ring-0 focus:ring-offset-0"
                  onChange={(e) => setSearchText(e.target.value)}
                  value={searchText}
                  placeholder={searchLabel || "Search Options"}
                />
              </div>
            </div>

            <CommandList>
              <ConditionRenderer condition={list.length === 0}>
                <ConditionRenderer condition={process}>
                  <div className="flex items-center justify-center">
                    <LoaderCircle className="mr-2 h-6 w-6 animate-spin" />
                  </div>
                  <div className="text-sm px-3 pt-3">
                    {emptyListMessage || "No Options found."}
                  </div>
                </ConditionRenderer>
              </ConditionRenderer>
              <CommandGroup>
                <InViewComponent list={list} pageSize={100}>
                  {(option: any, index) => {
                    //  const label = displayOptionsLabel(option);
                    //  const isCurrentItemExist =
                    //    isCurrentOptionIsFiltered(label);
                    //  if (!isCurrentItemExist) {
                    //    return null;
                    //  }
                    return (
                      <CommandItem
                        className="text-sm"
                        key={index}
                        value={option}
                        onSelect={() => {
                          onChangeValue(option);
                          setOpen(false);
                        }}
                      >
                        <span className="flex flex-col text-left items-start hover-bg-white">
                          {option.supplier_name ? (
                            <span>
                              <b className="text-[#6982a7] font-[500] pr-1">
                                Supplier name:
                              </b>
                              {option.supplier_name}
                            </span>
                          ) : null}

                          {option?.address1 ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Address 1:
                              </b>
                              {option.address1}
                            </span>
                          ) : null}

                          {option.address2 ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Address 2:
                              </b>
                              {option.address2}
                            </span>
                          ) : null}
                          {option.country ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Country:
                              </b>
                              {option.country}
                            </span>
                          ) : null}
                          {option.city ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                City:
                              </b>
                              {option.city}
                            </span>
                          ) : null}
                          {option.pin_code ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Pin Code:
                              </b>
                              {option.pin_code}
                            </span>
                          ) : null}
                        </span>
                      </CommandItem>
                    );
                  }}
                </InViewComponent>

                {/* {list.map((option: any, index: number) => {
                  const label = displayOptionsLabel(option);
                  const isCurrentItemExist = isCurrentOptionIsFiltered(label);
                  if (!isCurrentItemExist) {
                    return null;
                  }
                  return (
                    <CommandItem
                      className="text-sm"
                      key={index}
                      value={option}
                      onSelect={() => {
                        onChangeValue(option);
                        setOpen(false);
                      }}
                    >
                      <span className="flex flex-col text-left items-start hover-bg-white">
                        {option.supplier_name ? (
                          <span>
                            <b className="text-[#6982a7] font-[500] pr-1">
                              Supplier name:
                            </b>
                            {option.supplier_name}
                          </span>
                        ) : null}

                        {option?.address1 ? (
                          <span>
                            <b className="text-[#6982a7]  font-[500]  pr-1">
                              Address 1:
                            </b>
                            {option.address1}
                          </span>
                        ) : null}

                        {option.address2 ? (
                          <span>
                            <b className="text-[#6982a7]  font-[500]  pr-1">
                              Address 2:
                            </b>
                            {option.address2}
                          </span>
                        ) : null}
                        {option.country ? (
                          <span>
                            <b className="text-[#6982a7]  font-[500]  pr-1">
                              Country:
                            </b>
                            {option.country}
                          </span>
                        ) : null}
                        {option.city ? (
                          <span>
                            <b className="text-[#6982a7]  font-[500]  pr-1">
                              City:
                            </b>
                            {option.city}
                          </span>
                        ) : null}
                        {option.pin_code ? (
                          <span>
                            <b className="text-[#6982a7]  font-[500]  pr-1">
                              Pin Code:
                            </b>
                            {option.pin_code}
                          </span>
                        ) : null}
                      </span>
                    </CommandItem>
                  );
                })} */}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </>
  );
};
